import * as React from "react";

import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouterAndCustomerNotifications } from "components/shared/StorefrontWizard/LobQueryRouterAndCustomerNotifications/LobQueryRouterAndCustomerNotifications";

export interface WizardForTripsHeroProps {
  isStorefrontPage: boolean;
  wizardLOBs: FlexComponent[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
}

export const WizardForTripsHero: React.FC<WizardForTripsHeroProps> = ({
  isStorefrontPage,
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
}) => (
  <>
    <LobQueryRouterAndCustomerNotifications
      customerNotificationsClassName="all-x-padding-six all-t-padding-twelve"
      isStorefrontPage={isStorefrontPage}
      wizardLOBs={wizardLOBs}
    />

    <div className="all-y-padding-three SimpleContainer">
      <LobFormWithTabs context={context} lobForms={wizardFormChildren} trackOnChangeTab={trackOnChangeTab} />
    </div>
  </>
);
